import React from 'react';
import {bool, func, oneOf, string} from 'prop-types';
import {Link} from 'react-router-dom';
import {DragSource, DropTarget} from 'react-dnd';
import {FormattedMessage} from 'react-intl';
import classnames from 'classnames';
import compose from 'recompose/compose';
import {Radio, Segment, Container, Icon} from 'semantic-ui-react';
import keys from 'lodash/keys';
import values from 'lodash/values';
import {EmptyFunc, platformMappings} from 'utils/DBUtils';
import SortableStepTypes from './SortableStepTypes';
import {makeBreakStepSectionKey} from "../../utils/DBUtils";

const stepDragSource = {
  beginDrag: props => ({
    id: props.id,
    platformKey: props.platformKey,
    originalIndex: props.findStep(props.platformKey, props.id).index
  }),
  endDrag: (props, monitor) => {
    const { id: draggedId } = monitor.getItem();
    const { id: overId, platformKey } = monitor.getDropResult();

    if (monitor.didDrop() && draggedId !== overId) {
      const { index: overIndex } = props.findStep(platformKey, overId);
      props.moveStep(platformKey, draggedId, overIndex);
    }
  }
};

const stepDropTarget = {
  drop: (props, monitor) => props
};

const PlatformStep = ({
  id,
  challengeId,
  sortable = true,
  label,
  stepType,
  platformName,
  synchronized,
  publishStep,
  isLastEnabledStep = false,
  onChange = EmptyFunc,
  isDragging, // for styling, if needed
  connectDragSource,
  connectDropTarget
}) => {

  const className = classnames({
    [`db-platform-step fadeInDown animResponse db-platform-step-${platformName.toLowerCase()}`]: synchronized && publishStep,
    'db-platform-step fadeInDown animResponse db-platform-step-inactive': synchronized && !publishStep,
    'db-platform-step-disabled fadeInDown animResponse': !(synchronized && publishStep),
    'db-platform-step-draggable': sortable
  });

  const step = (
    <div>
      <Segment className={className}>
        {!(synchronized && publishStep) ? "" :
        <div className="drag-container">
          <Icon name="move" />
        </div>}

        <h4>
          <Link to={`/break/${challengeId}/edit?openSection=${makeBreakStepSectionKey(id)}`}>
            <span>{label || <FormattedMessage id={'step_types.' + stepType.toLowerCase()}/>}</span>
          </Link>
            {synchronized && (
            <span title={isLastEnabledStep ? 'At least one step must stay enabled' : undefined}>
              <Radio
                toggle
                checked={!!publishStep}
                disabled={isLastEnabledStep}
                onChange={(event, data) => onChange(data.checked)}
                className="db-blue-radio" />
            </span>
          )}
        </h4>
      </Segment>
    </div>
  );

  return connectDragSource(connectDropTarget(step));
};

PlatformStep.propTypes = {
  id: string,
  itemType: oneOf(values(SortableStepTypes)).isRequired,
  sortable: bool,
  label: string,
  stepType: string.isRequired,
  platformKey: oneOf(keys(platformMappings)).isRequired,
  platformName: oneOf(values(platformMappings)).isRequired,
  synchronized: bool.isRequired,
  publishStep: bool.isRequired,
  isLastEnabledStep: bool,
  onChange: func,
  connectDragSource: func.isRequired,
  connectDropTarget: func.isRequired,
  isDragging: bool.isRequired,
  findStep: func.isRequired,
  moveStep: func.isRequired
};

export default compose(
  DropTarget(props => props.itemType, stepDropTarget, connect => ({
    connectDropTarget: connect.dropTarget()
  })),
  DragSource(props => props.itemType, stepDragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }))
)(PlatformStep);



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/PlatformStep.jsx